export default {
  pageNotFound: 'Pagina niet gevonden',
  youRedirected: 'Je word doorgestuurd naar de startpagina',
  second: 'seconde',
  seconds: 'seconden',
  redirect: 'doorsturen naar de startpagina',
};
